"use strict";

exports.__esModule = true;
var _HistoricalPartCountContext = require("./HistoricalPartCountContext");
Object.keys(_HistoricalPartCountContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HistoricalPartCountContext[key]) return;
  exports[key] = _HistoricalPartCountContext[key];
});
var _HistoricalPartCountController = require("./HistoricalPartCountController");
Object.keys(_HistoricalPartCountController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HistoricalPartCountController[key]) return;
  exports[key] = _HistoricalPartCountController[key];
});